// tslint:disable:no-inferrable-types
// tslint:disable:variable-name

import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AbstractService } from 'src/app/services/data/abstract.service';
import { ABSTRACT_STATUS_ENUM, GLOBAL_VARIABLES } from '../../data/const.data';
import { AbstractVideoLinkForm } from 'src/app/models/abstract.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
@UntilDestroy()
@Component({
  selector: 'app-video-link-abstract',
  templateUrl: './video-link-abstract.component.html',
  styleUrls: ['./video-link-abstract.component.css']
})
export class VideoLinkAbstractComponent implements OnInit {
  readonly allowedStatuses: string[] = [
    ABSTRACT_STATUS_ENUM.ACCEPTED,
  ];

  // tslint:disable:no-inferrable-types
  @Input() confId: number = 0;
  @Input() abstractId: string = '';
  @Input() videoLink: string = '';
  @Input() status: string = '';

  isShowForm: boolean = true;

  readonly linkRegex: RegExp = GLOBAL_VARIABLES.REGEXP_LINK;

  myForm: UntypedFormGroup;

  constructor(
    private _srv: AbstractService,
  ) {
  }

  ngOnInit(): void {
    if (!this.allowedStatuses.includes(this.status)) {
      this.isShowForm = false;
      return;
    }

    this.videoLink = this.videoLink !== null && this.videoLink !== undefined ? this.videoLink : '';

    this.myForm = new UntypedFormGroup({
      videoLink: new UntypedFormControl(`${ this.videoLink }`, [Validators.pattern(this.linkRegex)])
    });
  }

  onLog(ev: any) {
    console.log(ev);
  }

  onSave() {
    const link = this.myForm.get('videoLink').value;
    const form: AbstractVideoLinkForm = new AbstractVideoLinkForm(link);

    this._srv.saveVideoLink(this.confId, this.abstractId, form)
    .pipe(
      untilDestroyed(this),
      tap(res => console.log(res))
    ).subscribe();
  }

  onFollowTheLink() {
    const link = this.myForm.get('videoLink').value;
    window.open(link);
  }

  private isValidURL(url: string): boolean {
    // const regex = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
    const regex: RegExp = GLOBAL_VARIABLES.REGEXP_LINK;
    return regex.test(url);
  }
}
